import { combineReducers } from "@reduxjs/toolkit";
import appOriginReducer from "./appOriginReducer";
import enterpriseDetailReducer from "./enterpriseDetailReducer";
import pageNotFoundReducer from "./pageNotFoundReducer";
import profileReducer from "./Profile/profile";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

const rootReducers = combineReducers({
  location: appOriginReducer,
  enterprise: enterpriseDetailReducer,
  pageNotFound: pageNotFoundReducer,
  profile: profileReducer,
});
const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducers);
export default persistedReducer;
